import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { numberFormat, onlyNumber } from '../../../Utils/Common';
import Spinner, { MiniSpinner } from '../../layouts/Spinner';
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import { reportChecker } from '../../../redux/actions/reports/reports.actions';

function ReportGenerate({
    report: { reportData },
    show,
    onHide,
    reportChecker,
}) {
    const handleDownloadCSV = () => {
        if (reportData.fileUrl) {
            window.open(reportData.fileUrl, '_blank');
        }
    };

    //** REPORT DATA */
    //** HANDLE REPORTS DATA */
    const [statusMessage, setStatusMessage] = useState('');

    useEffect(() => {
        // If we have a job queued, we might set a message
        if (reportData.status === 'queued') {
            setStatusMessage(
                `Your ${reportData.name} is being generated. This may take a few minutes. Once ready you can download it from the Download Section.`
            );
        }
    }, [reportData]);

    // Handle user click to check status
    const handleCheckStatus = () => {
        if (reportData.jobId) {
            reportChecker(reportData.jobId);
        }
    };

    // If the job is completed, we can do an immediate download
    useEffect(() => {
        if (reportData.status === 'completed' && reportData.fileUrl) {
            setStatusMessage('Your CSV is ready. Click "Download CSV" below.');
        } else if (reportData.status === 'failed') {
            setStatusMessage(
                'Failed to generate the CSV. Please try again later.'
            );
        }
    }, [reportData]);

    //** PROGRESS OF REPORTS */
    // Local progress state (0 - 100)
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        let intervalId;

        if (
            reportData.status === 'queued' ||
            reportData.status === 'in-progress'
        ) {
            setProgress(0);

            intervalId = setInterval(() => {
                // call the action that does reportChecker(jobId)
                if (reportData.jobId) {
                    reportChecker(reportData.jobId);
                }

                setProgress((prev) => {
                    // if we're below 95%, increment in small steps (like +10)
                    if (prev < 95) {
                        return prev + 3;
                    } else {
                        // keep it pinned at 95% until completed
                        return 95;
                    }
                });
            }, 1000);
        }

        // Clean up when unmount or if status changes
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [reportData.status, reportData.jobId, reportChecker]);

    useEffect(() => {
        if (reportData.status === 'completed') {
            setProgress(100);
        }
    }, [reportData.status]);

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            <Modal.Header closeButton>
                <Modal.Title>Generate Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {reportData.status === 'queued' ||
                reportData.status === 'in-progress' ? (
                    <div className="text-center" style={{ height: '200px' }}>
                        <div className="m-auto">
                            <p>{statusMessage}</p>

                            {/* Small progress bar */}
                            <div
                                className="progress"
                                style={{
                                    width: '200px',
                                    height: '20px',
                                    backgroundColor: '#e9ecef',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    margin: 'auto',
                                }}
                            >
                                <div
                                    className="progress-bar d-flex justify-content-center align-items-center"
                                    role="progressbar"
                                    style={{
                                        width: `${progress}%`,
                                        transition: 'width 0.5s',
                                        backgroundColor: '#007bff',
                                    }}
                                >
                                    <div style={{ marginLeft: '20px' }}>
                                        {progress}%
                                    </div>
                                </div>
                            </div>

                            {/* Optionally re-activate the manual check button if you like */}
                            {/* <button onClick={handleCheckStatus}>Check Status</button> */}
                        </div>
                    </div>
                ) : reportData.status === 'completed' ? (
                    <div className="text-center" style={{ height: '200px' }}>
                        <div className="m-auto">
                            <p>{statusMessage}</p>
                            <button
                                className="btn btn-primary m-1"
                                onClick={handleDownloadCSV}
                            >
                                Download CSV
                            </button>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );
}
const mapStateToProps = (state) => ({
    report: state.report,
    show: state.report.generate_report,
});

export default connect(mapStateToProps, { reportChecker })(ReportGenerate);
